import type { ServiceRepository } from '../repositories/service-repository';

export class DeleteServiceUseCase {
  constructor(private readonly repository: ServiceRepository) {}

  async execute(userId: string, id: string): Promise<void> {
    return this.repository.delete(userId, id);
  }
}
